import { Plus, X } from '@phosphor-icons/react';
import type { FC } from 'react';
import type { QuickHelpTab } from '@providers/QuickHelp/types';
import styles from './QuickHelpPanel.module.css';

interface Props {
    tabs: QuickHelpTab[];
    activeTabId: string | null;
    onSelectTab: (tabId: string) => void;
    onCloseTab: (tabId: string) => void;
    onNewTab: () => void;
}

const QuickHelpTabBar: FC<Props> = ({
    tabs,
    activeTabId,
    onSelectTab,
    onCloseTab,
    onNewTab,
}) => (
    <div className={styles.tabBar}>
        <div className={styles.tabsScroll}>
            <div className={styles.tabsRow}>
                {tabs.map((tab) => {
                    const isActive = tab.id === activeTabId;
                    return (
                        <button
                            key={tab.id}
                            type="button"
                            className={`${styles.tab} ${isActive ? styles.tabActive : ''}`}
                            onClick={() => onSelectTab(tab.id)}
                            title={tab.title}
                        >
                            <span className={styles.tabLabel}>{tab.title}</span>
                            <span
                                className={styles.tabClose}
                                role="button"
                                tabIndex={0}
                                aria-label={`Close ${tab.title}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onCloseTab(tab.id);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.stopPropagation();
                                        onCloseTab(tab.id);
                                    }
                                }}
                            >
                                <X size={9} weight="bold" />
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>

        <button
            type="button"
            className={styles.newTabButton}
            onClick={onNewTab}
            aria-label="New chat"
            title="New chat"
        >
            <Plus size={12} weight="bold" />
        </button>
    </div>
);

export default QuickHelpTabBar;
